import { useQuery } from '@apollo/react-hooks'
import settings from '../../components/settings'
import getSbmCalendar from '../../../graphql/GetSbmCalendarQuery.graphql'

const DAY = 24 * 60 * 60 * 1000
const MAX_DAYS = 60
const NOW = new Date()
const NOW_DATE = NOW.toISOString().split('T')[0]
const TOMORROW = new Date(NOW.getTime() + DAY)
const TOMORROW_DATE = TOMORROW.toISOString().split('T')[0]
const MAX_DATE = new Date(NOW.getTime() + MAX_DAYS * DAY)
  .toISOString()
  .split('T')[0]

export const getDateRange = (meetingTypeId) => {
  let specialMeetingtype = false
  if (settings.brand === 'magnet') {
    switch (parseInt(meetingTypeId, 10)) {
      case 5: // 3 slot in-store TEST
      case 6: // discovery TEST
      case 7: // 3 slot in-store PROD
      case 8: // discovery PROD
      case 11: // 3 slot in-store PROD - magnet2 || 3 slot in-store TEST - magnettest2
      case 12: // discovery PROD - magnet2 || discovery TEST - magnettest2
        specialMeetingtype = true
        break
      default:
        break
    }
  }

  const fromDate =
    settings.disableSameDayBooking && !specialMeetingtype
      ? TOMORROW_DATE
      : NOW_DATE

  return { fromDate, toDate: MAX_DATE }
}

const useSbmCalendar = ({
  meetingType,
  storeId,
  locationId,
  sbmInstance,
  serviceProviderId,
}) => {
  if (!storeId || !meetingType) return null

  const { fromDate, toDate } = getDateRange(meetingType)
  const { data, loading, error } = useQuery(getSbmCalendar, {
    fetchPolicy: 'no-cache',
    variables: {
      storeId,
      locationId,
      meetingType,
      fromDate,
      toDate,
      sbmInstance,
      serviceProviderId,
    },
  })

  if (!data)
    return {
      days: [],
      loading,
      error,
    }

  const days = (data && data.getSbmCalendar) || []

  return {
    days,
    loading,
    error,
  }
}

export default useSbmCalendar
